import { useState } from "react";

export const usePaginationState = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState<number | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  return {
    rows,
    setRows,
    page,
    setPage,
    totalPages,
    setTotalPages,
    loading,
    setLoading,
  };
};
